import React from 'react';
import '../less/TransferTableNew.less';
import DOMPurify from 'utils/sanitize';
import btn_icon from '../img/btn_icon.svg';
import { getSafeLinkProps } from '../../../../helpers/utils/urlSecurity';
import { ReactSVG } from 'react-svg';

export default function TransferTableNew() {
  const { data, title, titleTag, text, btnLink, btnText } = this.props;

  const TitleTag = titleTag || 'h2';

  function getIsMobile(width, columns) {
    if (width <= 767 && columns <= 2) return true;
    if (width <= 960 && columns === 3) return true;
    if (width <= 1120 && columns >= 4) return true;
    return false;
  }

  const isMobile = getIsMobile(this.state.width, data.columns.length);

  const footer = (
    <>
      {text && <div className="transfer-table-new__text" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(this.l10n(text))}}></div>}
      {(btnLink && btnText) && (
        <a className="transfer-table-new__btn btn-transfer-table-new" {...getSafeLinkProps(btnLink)}>
          <ReactSVG src={btn_icon} className="btn-transfer-table-new__icon"/>
          <span className="btn-transfer-table-new__text">{this.l10n(btnText)}</span>
        </a>
      )}
    </>
  );

  if (isMobile) {
    return (
      <div className="transfer-table-new mobile">
        <div className="container">
          {title && <TitleTag className="transfer-table-new__title">{this.l10n(title)}</TitleTag>}
          <div className="transfer-table-new__body">
            {data.data.map(row => (
              <div key={row.id} className="transfer-table-new__row">
                <div className="transfer-table-new__subtitle" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(this.l10n(row[data.columns[0]]))}}>
                </div>
                <div className="transfer-table-new__list">
                  {data.columns.slice(1).map((column, index) => (
                    <div key={column} className="transfer-table-new__item">
                      <div className="transfer-table-new__label" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(this.l10n(data.headers[index + 1]))}}></div>
                      <div className="transfer-table-new__value" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(this.l10n(row[column]))}}></div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
          {footer}
        </div>
      </div>
    );
  }

  return (
    <div className="transfer-table-new">
      <div className="container">
        {title && <TitleTag className="transfer-table-new__title">{this.l10n(title)}</TitleTag>}
        <div className="transfer-table-new__body">
          <div className="transfer-table-new__row">
            {data.headers.map(header => (
              <div key={header} className="transfer-table-new__cell transfer-table-new__cell_header" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(this.l10n(header))}}></div>
            ))}
          </div>
          {data.data.map(row => (
            <div key={row.id} className="transfer-table-new__row">
              {data.columns.map(column => (
                <div key={column} className="transfer-table-new__cell" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(this.l10n(row[column]))}}>
                </div>
              ))}
            </div>
          ))}
        </div>
        {footer}
      </div>
    </div>
  );
}
